<template>
  <div class="menu-item d-flex w-100" v-on="$listeners">
    <centered-container
      :class="['w-50', {'muted-text': muted === true}]"
      horizontal="left"
    >{{fullName}}</centered-container>
    <centered-container :class="['w-' + textWidth]" horizontal="left">{{value}}</centered-container>
    <centered-container v-if="withIcon" class="w-10 nav">
      <slot name="icon"></slot>
    </centered-container>
    <centered-container v-if="nav" class="w-10 nav">
      <cms-icon width="15" height="15">
        <icon-arrow />
      </cms-icon>
    </centered-container>
  </div>
</template>

<script>
import arrowNav from "../icons/arrow-nav";

export default {
  name: "cms-menu-row",
  components: {
    "icon-arrow": arrowNav,
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    nav: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    textWidth() {
      return 50 - this.nav * 10 - this.withIcon * 10;
    },
    fullName() {
      return this.name + (this.required ? "*" : "");
    },
  },
};
</script>

<style scoped lang="scss">
.menu-item {
  height: 3.2rem;
  width: 100%;
}

span.link {
  color: $dark-sky-blue-color;
}

.nav {
  color: $dark-sky-blue-color;
}
</style>
